import { useNavigate } from 'react-router-dom';
import useOrders from '../../hooks/react-query/useOrder';
import { mapStepToText } from '../../utils/helper';
import OrderCarCard from '../cars/orderCarCard';

export const OrderedCarsSection = () => {
  const { data, isLoading } = useOrders();
  const navigate = useNavigate();

  return (
    <div className="flex w-full flex-col gap-[10px] lg:bg-[#FFFFFF99] lg:rounded-[12px] lg:p-6 lg:min-h-[298px]">
      <div className="w-full flex justify-between items-center">
        <h3>Εκκρεμείς παραγγελίες</h3>
        <button
          type="button"
          className="text-[#D4002A] h6"
          onClick={() => navigate('/portal/my-cars?active=ordered')}
        >
          Προβολή όλων
        </button>
      </div>
      <div className="grid grid-cols-1 gap-3  max-lg:bg-[#FFFFFF99] max-lg:rounded-[12px] max-lg:p-6 ">
        {isLoading ? (
          Array.from({ length: 3 }, (_, index) => (
            <div
              className={
                'p-3 bg-white flex w-full items-center justify-between gap-3 rounded-lg'
              }
            >
              <div className="flex animate-pulse items-center justify-center gap-3">
                <div className="rounded-full bg-powdergrey p-3 h-5 w-5 " />
                <div className="flex flex-col gap-1">
                  <div className="w-20 h-5  bg-powdergrey  rounded-full" />
                  <div className="w-16 h-5 bg-powdergrey  rounded-full" />
                </div>
              </div>
              <div className="w-20 h-5  bg-powdergrey rounded-full" />
            </div>
          ))
        ) : data && data.data.length > 0 ? (
          data.data.slice(0, 3).map((car) => (
            <OrderCarCard
              isDashbord={true}
              carData={{
                title: car.carTitle,
                subTitle: mapStepToText(car?.state?.step),
                info: '',
                step: car.state?.step,
              }}
              key={car.cncode}
            />
          ))
        ) : (
          <p className="text-center text-body">Δεν υπάρχουν εκκρεμείς παραγγελίες</p>
        )}
      </div>
    </div>
  );
};
